module.exports = __webpack_public_path__ + "static/media/hardwareFeat.38cb3d49.jpg";